// contactListUtils.js

/**
 * Combines intersection data with reference data to enrich items.
 * @param {Array} intersectionData - The intersection data array.
 * @param {Array} referenceData - The reference data array.
 * @param {string} intersectionKey - The key in the intersection data to match.
 * @param {string} referenceKey - The key in the reference data to match.
 * @param {string} referenceNameKey - The key in the reference data to extract the name.
 * @param {string} newKeyName - The key name to store the extracted name in the combined data.
 * @param {Array} originalContacts - The array of original contacts.
 * @returns {Array} The combined data array.
 */
export const combineIntersectionData = (
  intersectionData,
  referenceData,
  intersectionKey,
  referenceKey,
  referenceNameKey,
  newKeyName
) => {
  const referenceMap = new Map(referenceData.map((ref) => [ref[referenceKey], ref]));

  return intersectionData.map((item) => {
    // Find the matching reference item
    const referenceItem = referenceMap.get(item[intersectionKey]);

    // Combine the intersection item with the reference item's name
    return {
      ...item,
      [newKeyName]: referenceItem ? referenceItem[referenceNameKey] : 'N/A',
    };
  });
};
